import { render, staticRenderFns } from "./boarding.vue?vue&type=template&id=66715f29&scoped=true&"
import script from "./boarding.vue?vue&type=script&lang=js&"
export * from "./boarding.vue?vue&type=script&lang=js&"
import style0 from "./boarding.vue?vue&type=style&index=0&lang=css&"
import style1 from "./boarding.vue?vue&type=style&index=1&id=66715f29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66715f29",
  null
  
)

export default component.exports